import React from 'react';
import BaseNode from './BaseBlockNode';
import { renderValue } from '../../helpers/node';
import { renderPhasesParams } from '../../../constants/phases';

function LoadSoftConstraintNode(props) {
  const {
    maxLoadSC,
    presentLoadPhA, presentLoadPhB, presentLoadPhC,
    presentPowerPhA, presentPowerPhB, presentPowerPhC,
  } = props;

  return (
    <BaseNode
      {...props}
      staticParams={[
        { label: 'Max Load', value: renderValue(maxLoadSC, 'A') },
      ]}
      dynamicParams={[
        ...renderPhasesParams({
          presentLoadPhA,
          presentLoadPhB,
          presentLoadPhC,
          presentPowerPhA,
          presentPowerPhB,
          presentPowerPhC,
        }),
      ]}
      hidePhases
    />
  );
}

export default LoadSoftConstraintNode;
